"use client";

import Link from "next/link";

import { Button } from "@/components/ui/button";
import { LINKS } from "@/components/Navbar";
import LanguageSwitcher from "@/components/LanguageSwitcher";

import { LinkedIn, Logo } from "@/assets";
// import LanguageSwitcher from "@/app/[lang]/language-switcher";

const legalLinks = [
  {
    label: "Privacy Policy",
    href: "/privacy-policy",
  },
  {
    label: "Terms of Service",
    href: "/terms-of-service",
  },
];

const socialLinks = [
  {
    label: "LinkedIn",
    href: "https://www.linkedin.com/company/emerald-power1/",
    icon: LinkedIn,
  },
];

export default function Footer() {
  const footerLinks = [
    ...LINKS,
    {
      label: "Articles",
      href: "/articles",
    },
  ];

  const year = new Date().getFullYear();

  return (
    <footer className="bg-foreground text-white rounded-t-[50px] mx-4">
      <div className="flex flex-col items-center sm:items-start gap-4 content pt-10 pb-6">
        <Logo className="h-6 md:h-10" />
        <div className="w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-[2fr_1fr] items-start mt-6 mb-10 gap-10">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 max-w-[320px] max-sm:justify-self-center text-center sm:text-left">
            {footerLinks?.map((link) => (
              <Link key={link.href} href={link.href}>
                {link.label}
              </Link>
            ))}
          </div>
          <div className="flex flex-col items-center sm:items-start gap-6 max-w-[360px] max-sm:mx-auto">
            <div className="text-2xl text-balance text-center sm:text-left">
              Take the next step toward Net Zero today!
            </div>
            <Button
              variant="light"
              showArrow
              className="max-w-[200px] w-fit"
              asChild
            >
              <Link href="/book-demo">Book a Demo</Link>
            </Button>
          </div>
        </div>
        <div className="w-full">
          <div className="flex justify-between items-center flex-col sm:flex-row gap-4">
            <div className="flex gap-5 items-center flex-col sm:flex-row">
              {legalLinks?.map((link) => (
                <Button
                  variant="linkSecondary"
                  size="xs"
                  key={link.href}
                  asChild
                >
                  <Link href={link.href}>{link.label}</Link>
                </Button>
              ))}
            </div>
            <LanguageSwitcher />
          </div>
          <div className="border-t border-white flex justify-between items-center pt-4 mt-4 flex-col sm:flex-row gap-6">
            <div className="text-xs text-center sm:text-left">
              &copy; {year} Emerald Power All Rights Reserved
            </div>
            <div className="flex gap-2">
              {socialLinks?.map((link) => (
                <Link
                  key={link.href}
                  href={link.href}
                  aria-label={link.label}
                  target="_blank"
                >
                  <link.icon className="size-5" />
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
